export default __webpack_public_path__ + "static/media/mysql.822ba7d7.svg";